module.exports = __webpack_public_path__ + "img/slika45.346cdfca.jpg";